<template>
  <div class="pb-3" >
    <va-card :title="$t('games.cards.result')">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="row">
            <div class="flex md12">
              <div class="mb-1">
                <p>
                  <b>Clube 1:</b>
                  {{updateData.club1.name}}
                </p>
              </div>
              <ValidationProvider rules="required|numeric" name="Pontos Club 1" v-slot="{ errors }">
                <va-input
                  v-model="pts1"
                  :label="$t('games.forms.ptsClub1Label')"
                  :placeholder="$t('games.forms.ptsClub1Placeholder')"
                  :success="errors.length == 0 && pts1 >= 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <div class="mb-1">
                <p>
                  <b>Clube 2:</b>
                  {{updateData.club2.name}}
                </p>
              </div>
              <ValidationProvider rules="required|numeric" name="Pontos Club 2" v-slot="{ errors }">
                <va-input
                  v-model="pts2"
                  :label="$t('games.forms.ptsClub2Label')"
                  :placeholder="$t('games.forms.ptsClub2Placeholder')"
                  :success="errors.length == 0 && pts2 >= 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'GamesResultsAddUpdate',
  props: {
    page: {
      type: Number,
      required: true,
    },
    updateData: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      result: {
        game_id: 0,
        pts_club1: 0,
        pts_club2: 0,
      },
      update: false,
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  created () {
    this.updated = false
    if (this.updateData !== null) {
      this.result_get(this.updateData)
    }
  },
  watch: {
    updateData (value) {
      if (this.updateData !== null) {
        this.result_get(this.updateData)
      } else {
        this.result.pts_club1 = 0
        this.result.pts_club2 = 0
      }
    },
  },
  computed: {
    pts1: {
      get () {
        return this.result.pts_club1
      },
      set (value) {
        if (value >= 0) {
          this.result.pts_club1 = value
        }
      },
    },
    pts2: {
      get () {
        return this.result.pts_club2
      },
      set (value) {
        if (value >= 0) {
          this.result.pts_club2 = value
        }
      },
    },
  },
  methods: {
    cancel () {
      this.$emit('showAdd', false)
    },
    result_get (data) {
      this.result.game_id = data.id
      this.$apollo.addSmartQuery('result', {
        query: gql`query MyQuery($id: Int!) {
          result(where: {game_id: {_eq: $id}}) {
            id
            game_id
            pts_club1
            pts_club2
          }
        }
        `,
        variables: {
          id: data.id,
        },
        manual: true,
        result ({ data, loading }) {
          if (!loading && data.result.length > 0) {
            this.update = true
            const result = data.result[0]
            this.result = Object.assign({}, {
              pts_club1: result.pts_club1,
              pts_club2: result.pts_club2,
              id: result.id,
            })
          } else {
            this.result.pts_club1 = 0
            this.result.pts_club2 = 0
          }
        },
      })
    },
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      const self = this
      this.$apollo
        .mutate({
          mutation: (
            this.update ? gql`
                mutation MyMutation($pts_club2: Int!, $pts_club1: Int!, $id: Int!) {
                  update_result_by_pk(pk_columns: {id: $id}, _set: {pts_club1: $pts_club1, pts_club2: $pts_club2}) {
                    id
                  }
                }
                ` : gql`
                mutation MyMutation($game_id: Int!, $pts_club2: Int!, $pts_club1: Int!) {
                  insert_result(objects: {game_id: $game_id, pts_club1: $pts_club1, pts_club2: $pts_club2}) {
                    affected_rows
                  }
                }
                `),
          variables: this.update ? {
            pts_club1: this.result.pts_club1,
            pts_club2: this.result.pts_club2,
            id: this.result.id,
          } : {
            pts_club1: this.result.pts_club1,
            pts_club2: this.result.pts_club2,
            game_id: this.result.game_id,
          }
          ,
        })
        .then(data => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.result.pts_club1 = 0
          self.result.pts_club2 = 0
          self.$emit('showAdd', false)
          self.$emit('showMore', self.page)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.successUpdate' : 'toasts.successCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.result.pts_club1 = 0
          self.result.pts_club2 = 0
          self.$emit('showAdd', false)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.errorUpdate' : 'toasts.errorCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss">
.va-message-list {
  &__message {
    vertical-align: middle;
    font-size: $font-size-mini;
    color: rgb(248, 112, 109);
  }
}

.position {
  position: relative;
}
</style>
